import React, { Fragment } from 'react';
import Input from '../../../layout/input/Input';
import InputTextArea from '../../../layout/input/InputTextArea';
import Panel from '../../../layout/panel/Panel';

class Social extends React.Component {
    constructor(props) {
        super(props);
}

    render(){
        return(
            <section id="social">
                <Panel md={12} xs={12} sm={12} lg={12} title={"Redes Sociais (Página Principal)"}
                    >
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="titulo"
                        nome="titulo"
                        tooltip="Insira o título que aparecerá na página principal na aba de Redes Sociais"                        
                        value={this.props.socialPrincipal.titulo}                                            
                        onChange={e => this.props.onChangeForPropsSocialPrincipal(e)}
                    >
                        Título (Página Inicial).
                    </Input>
                    <InputTextArea
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="texto"
                        nome="texto" 
                        rows = {2}
                        tooltip="Insira o texto que aparecerá na página principal na aba de Redes Sociais"
                        value={this.props.socialPrincipal.texto} 
                        onChange={e => this.props.onChangeForPropsSocialPrincipal(e)}                    
                    >
                        Texto (Página Inicial)                     
                    </InputTextArea>
                </Panel>
                </section>
        )
    }

}

export default Social;